// extracted by mini-css-extract-plugin
export default {"container":"EventsConfiguration_container__NphFg","innerContainer":"EventsConfiguration_innerContainer__9jyDq","infoCard":"EventsConfiguration_infoCard__16HWJ"};